import SimpleQuantity from './SimpleQuantity';

export default SimpleQuantity;
export { SimpleQuantity };
